import React, { useEffect } from 'react';

export default function ConsumerCIR({ reportData }) {
  // Helper to format date if available, otherwise fallback to the image's static date
  const formatDate = (dateString) => {
    if (!dateString) return "27-07-2026";
    try {
      const [year, month, day] = dateString.split('+')[0].split('T')[0].split('-');
      return `${day}-${month}-${year}`;
    } catch {
      return dateString;
    }
  };


  useEffect(() => {
    console.log("report data", reportData);
    

  }, [reportData])

  const asset = reportData?.asset;
  const personal = reportData?.personal;
  const scoreData = reportData?.score;


  const getName = (name) => {
    const arr = name.split(" ")

    let finalName;

    if (arr.length < 3 ) {
      finalName = arr.join(" ")
    } else {
      let firstname = arr[0]
      let middleName = arr[1]
      let lastName = arr[arr.length - 1]

      finalName = firstname + " " + middleName + " " + lastName
    }

    return finalName
  }

  return (
    <div className="w-full max-w-5xl bg-white font-sans text-sm pb-2">
      
      {/* CUSTOMER CIR HEADER */}
      <div className="bg-[#FFD700] py-1  ">
        <h1 className="text-[18px] font-medium  text-black uppercase tracking-wide">
          CUSTOMER CIR
        </h1>
      </div>

      {/* META INFO BLOCK */}
      <div className="grid grid-cols-2 gap-x-8  ">
        {/* Left Column */}
        <div className="">
          <div className="flex p-0 -mb-2 justify-start gap-1">
            <span className="  p-0   tracking-wider  uppercase italic text-[9px]">CONSUMER:</span>
            <span className="  p-0 text-black font-bold text-[9px]">{getName(personal?.name) || "N/A"}</span>
          </div>
          <div className="  p-0 flex -mb-2 justify-start gap-1">
            <span className="  p-0   tracking-wider italic  uppercase text-[9px]">MEMBER ID:</span>
            <span className="  p-0 text-black font-bold text-[9px]">{asset?.memberId || ""}</span>
          </div>
          <div className="  p-0 flex -mb-2 justify-start gap-1">
            <span className="  p-0   tracking-wider italic  uppercase text-[9px]">MEMBER REFERENCE NUMBER:</span>
            <span className="  p-0 text-black font-bold text-[9px]">{asset?.TrueLinkCreditReport?.ReferenceKey || ""}</span>
          </div>
        </div>

        {/* Right Column */}
        <div className="  p-0 ">
          <div className="  p-0 flex  -mb-2 gap-1 ">
            <span className="  p-0  tracking-wider italic  uppercase text-[9px]">DATE:</span>
            <span className="  p-0 text-black font-bold text-[9px]">{reportData?.reporteDate}</span>
          </div>
          <div className="  p-0 flex  -mb-2 gap-1 ">
            <span className="  p-0  tracking-wider italic  uppercase text-[9px]">TIME:</span>
            <span className="  p-0 text-black font-bold text-[9px]">{reportData?.time || new Date(Date.now()).toLocaleTimeString()}</span>
          </div>
          <div className="  p-0 flex  -mb-2 gap-1 ">
            <span className="  p-0  tracking-wider italic  uppercase text-[9px]">CONTROL NUMBER:</span>
            <span className="  p-0 text-black font-bold text-[9px]">{reportData?.controlNumber || "N/A"}</span>
          </div>
        </div>
      </div>

      {/* THICK CYAN DIVIDER */}
      <div className="  p-0 h-[3px] bg-[#00a1de] mt-2"></div>

      {/* CONSUMER INFORMATION SECTION */}
      <div className="  p-0 ">
        <h2 className="  p-0 text-xs font-semibold text-gray-600 mt-2 uppercase tracking-wide">
          CONSUMER INFORMATION:
        </h2>
        
        <div className="  p-0 grid grid-cols-2 gap-x-8 ">
          <div className=" -mb-2  p-0 col-span-2 flex justify-start gap-1">
            <span className="  p-0    uppercase italic text-[9px] shrink-0">NAME:</span>
            <span className="  p-0 text-black font-bold text-[9px] uppercase ">
              {personal?.fullName || getName(personal?.name  || "N/A")}
            </span>
          </div>
          <div className=" -mb-2  p-0 flex gap-1">
            <span className="  p-0    uppercase italic text-[9px] shrink-0">DATE OF BIRTH:</span>
            <span className="  p-0 text-black font-bold text-[9px]">{personal?.dob || formatDate(personal.date_of_birth) || "N/A"}</span>
          </div>
          <div className=" -mb-2  p-0 flex gap-1">
            <span className="  p-0    uppercase italic text-[9px] shrink-0">GENDER:</span>
            <span className="text-black font-bold text-[9px]">{personal?.gender || "N/A"}</span>
          </div>
        </div>
      </div>

      {/* THICK GRAY DIVIDER */}
      <div className="h-[2px] mt-2 bg-gray-500 "></div>

      {/* CIBIL TRANSUNION SCORE(S) SECTION */}
      <div className="">
        <h2 className="text-xs font-semibold text-gray-600 mt-2 uppercase tracking-wide">
          CIBIL TRANSUNION SCORE(S):
        </h2>

        {/* Table Header */}
        <div className="grid grid-cols-12 gap-4 mb-1 text-[9px] font-bold  uppercase px-3">
          <div className="text-[#00a1de] col-span-5">SCORE NAME</div>
          <div className="text-[#00a1de] col-span-2">SCORE</div>
          <div className="text-[#00a1de] col-span-5">SCORING FACTORS</div>
        </div>

        {/* Table Body */}
        <div className="bg-[#e9ecef] grid grid-cols-12 gap-4  py-1 mb-2 items-center">
          <div className="col-span-5 font-bold text-[#0d85e0] text-[12px] uppercase">
            CIBIL TRANSUNION SCORE
          </div>
          <div className="col-span-2 font-bold text-[#2f5572] text-[20px] leading-none">
            {scoreData?.value || "N/A"}
          </div>
          <div className="col-span-5 text-black text-[9px] font-bold leading-tight flex flex-col justify-center ">
            <p>1. HIGH PROPORTION OF OUTSTANDING TRADES</p>
            <p>2. RECENT HIGH BALANCE BUILD ON BANKCARD TRADES</p>
          </div>
        </div>

        {/* Possible Range Box */}
        <div>
          {/* Box Header */}
          <div className="bg-[#dbe7ef]  px-3">
            <span className=" font-bold text-[9px] uppercase">
              POSSIBLE RANGE FOR CREDITVISION® SCORE
            </span>
          </div>
          
          {/* Box Body */}
          <div className="bg-[#f3f4f6] p-1 text-[9px] font-bold text-black  flex flex-col ">
            <div className="flex justify-between w-full -mb-2 pr-16">
              <span>Consumer with at least one trade on the bureau in last 36 months</span>
              <span className="text-[#016488] font-normal">: 300 (high risk) to 900 (low risk)</span>
            </div>
            <div className="flex justify-between w-full -mb-2 pr-16">
              <span>Consumer not in CIBIL database or history older than 36 months</span>
              <span className="text-[#016488] font-normal pr-[114px]">: -1</span>
            </div>
            <div className=" text-black font-bold">
              * At least one tradeline with information updated in last 36 months is required.
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}